import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IChecks = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="14"
            viewBox="0 0 18 14"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.75 14H0V12.4444H6.75V14ZM11.7712 11.76L9.28575 9.32556L8.25 10.4689L11.7743 14L18 7.43478L16.962 6.31556L11.7712 11.76ZM6.75 10.8702H0V9.31467H6.75V10.8702ZM12.75 7.77778H0V6.22222H12.75V7.77778ZM18 4.66667H0V3.11111H18V4.66667ZM18 1.55556H0V0H18V1.55556Z"
              fill={props.color}
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default IChecks;
